var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableDismissEventListener, ClickEventListener, DismissEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class TokenAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onBeforeDismiss = new AbortableDismissEventListener();
        /** @event */
        this.onDismiss = new DismissEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
    }
    /**
     * Gets the value of the token.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the value of the token.
     *
     * @param value - The new value
     */
    setValue(value) {
        this.setState({ value });
    }
    /**
     * Gets the color of the token.
     */
    getColor() {
        return this.state.color;
    }
    /**
     * Sets the color of the token.
     *
     * @param color - The new color
     */
    setColor(color) {
        this.setState({ color });
    }
    /**
     * Gets the color of the token label.
     */
    getLabelColor() {
        return this.state.labelColor;
    }
    /**
     * Sets the color of the token label.
     *
     * @param labelColor - The new label color
     */
    setLabelColor(labelColor) {
        this.setState({ labelColor });
    }
    /**
     * Gets the icon of the token.
     */
    getIcon() {
        return this.state.icon;
    }
    /**
     * Sets the icon of the token.
     *
     * @param icon - The new icon
     */
    setIcon(icon) {
        this.setState({ icon });
    }
    /**
     * Gets the configured sensitiveness for the token.
     */
    getSensitiveData() {
        return this.state.sensitiveData;
    }
    /**
     * Sets the sensitiveness of the token.
     *
     * @param sensitiveData - How sensitive the data is
     */
    setSensitiveData(sensitiveData) {
        this.setState({ sensitiveData });
    }
    /**
     * Gets the shape of the token.
     */
    getShape() {
        return this.state.shape;
    }
    /**
     * Sets the shape of the token.
     *
     * @param shape - The new shape
     */
    setShape(shape) {
        this.setState({ shape });
    }
    /**
     * Gets the size of the token.
     */
    getSize() {
        return this.state.size;
    }
    /**
     * Sets the size of the token.
     *
     * @param size - The new size
     */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Checks if the field value is being struckthrough.
     */
    isStrikethrough() {
        return Boolean(this.state.strikethrough);
    }
    /**
     * Sets if the field value should be struckthrough.
     *
     * @param strikethrough - If the field value should be struckthrough.
     */
    setStrikethrough(strikethrough) {
        this.setState({ strikethrough });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TokenAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TokenAPI.prototype, "onBeforeDismiss", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TokenAPI.prototype, "onDismiss", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TokenAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TokenAPI.prototype, "onContextMenuClick", void 0);
export { TokenAPI, };
//# sourceMappingURL=token-api.js.map